import { cva } from 'class-variance-authority'

import { buttonHeight, buttonRadius } from '../button/button.variants.ts'

// `bg-surface-base-disable` is a neutral gray across every theme (incl. partner co-branding) — unlike
// `surface-base-secondary`, which is white (the secondary-button surface) and would render invisible.
const skeletonVariants = cva('animate-pulse bg-surface-base-disable', {
  variants: {
    variant: {
      // Generic rectangle — size it with the width/height/radius props.
      block: 'rounded-20',
      // A body1 text line — height tracks the body1 line-height token (and BO/FO context).
      text: 'h-[var(--leading-40)] w-full rounded-10',
      // Matches a medium Button — geometry imported from button.variants.ts (single source of truth).
      button: `
        ${buttonHeight.medium}
        ${buttonRadius}
      `,
    },
  },
  defaultVariants: { variant: 'block' },
})

export { skeletonVariants }
